// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react'

const SystemHealth = () => {
  return <>200 OK</>
}

export default SystemHealth
